<template>

    <AjanlatBase :titleExtra="titleExtra"  v-if="masikrendszamVisible() || cegcsoportVisible() || kulcsokVisible()">

        <v-form ref="ajanlat-adatok" slot="biztositoi-adatok">

            <v-layout row wrap>

                <BnFormField v-if="masikrendszamVisible()" :attributes="masik_rendszam" />

                <BnFormField v-if="cegcsoportVisible()" :attributes="generali_cegcsopkedv_azon" />

                <BnFormField v-if="kulcsokVisible()" :attributes="gfb_casco_eredeti_kulcs"/>

                <BnFormField v-if="kulcsokVisible()" :attributes="gfb_casco_masolt_kulcs"/>

            </v-layout>
        </v-form>
    </AjanlatBase>
</template>

<script>
import AjanlatBase from '../KGFBAjanlatBase.vue';
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';
import offerData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/OfferData';

export default {
    name: 'AjanlatAdatokB13_V0',
    components: { AjanlatBase, BnFormField },
    mixins: [offerData],
    methods: {
        masikrendszamVisible() {
            return this.kedvezmenyek.tobbszerz === true;
        },
        cegcsoportVisible() {
            return this.kedvezmenyek.csoport === true;
        },
        kulcsokVisible() {
            return this.$store.getters.additions?.[this.biztositoid]?.tcasco === true;
        },
    },
    data() {
        return {
            gfb_casco_eredeti_kulcs: {
                type: 'select',
                label: 'Eredeti kulcsok száma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'gfb_casco_eredeti_kulcs',
                path: 'tarifaData.gfb_casco_eredeti_kulcs',
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    { key: 0, value: '0 db' },
                    { key: 1, value: '1 db' },
                    { key: 2, value: '2 db' },
                    { key: 3, value: '3 db' },
                    { key: 4, value: '4 db' },
                    { key: 5, value: '5 vagy több' },
                ],
            },
            gfb_casco_masolt_kulcs: {
                type: 'select',
                label: 'Másolt kulcsok száma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'gfb_casco_masolt_kulcs',
                path: 'tarifaData.gfb_casco_masolt_kulcs',
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    { key: 0, value: '0 db' },
                    { key: 1, value: '1 db' },
                    { key: 2, value: '2 db' },
                    { key: 3, value: '3 db' },
                    { key: 4, value: '4 db' },
                    { key: 5, value: '5 vagy több' },
                ],
            },
            masik_rendszam: {
                type: 'text',
                label: 'Másik biztosított gépjármű rendszáma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'masik_rendszam',
                path: 'tarifaData.masik_rendszam',
            },
            generali_cegcsopkedv_azon: {
                type: 'text',
                label: 'Cégcsoport kedvezményt igazoló szerződés szám',
                visible: true,
                editable: true,
                help: true,
                mezo: 'generali_cegcsopkedv_azon',
                path: 'tarifaData.generali_cegcsopkedv_azon',
            },
        };
    },
};
</script>
